// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"85":"js/contacts","192":"js/overview","772":"js/main"}[chunkId] + "." + {"85":"4b0cfae7","192":"4b0cfae7","772":"01f0656f"}[chunkId] + ".css";
};